import { EMethod } from "../types";
import { API_VERSION } from "../constants";

export const KENSAKU_KUN_ENDPOINT = {
  GET_ADVANCE_SEARCH_FILTER: {
    method: EMethod.POST,
    url: "/management/general/advanced-search",
    version: API_VERSION.V0,
  },
  GET_CRITERIA_SET_LIST: {
    method: EMethod.POST,
    url: "/management/criteria-sets/list",
    version: API_VERSION.V0,
  },
  DELETE_CRITERIA_SET: {
    method: EMethod.DEL,
    url: "/management/criteria-sets",
    version: API_VERSION.V0,
  },
  GET_CRITERIA_SET_DETAILS: {
    method: EMethod.POST,
    url: "/management/criteria-sets/detail",
    version: API_VERSION.V0,
  },
  SAVE_CRITERIA_SET: {
    method: EMethod.POST,
    url: "/management/criteria-sets/upsert",
    version: API_VERSION.V0,
  },
  GET_STAFF_BASIC_INFO: {
    method: EMethod.GET,
    url: "/user/staff/kensaku-information",
    version: API_VERSION.V1,
  },
  GET_EMPLOYEE_BASIC_INFO: {
    method: EMethod.GET,
    url: "/user/employee/kensaku-information",
    version: API_VERSION.V1,
  },
  GET_ALL_BUSINESS_ESTABLISHMENT: {
    method: EMethod.POST,
    url: "/corp/business-establishment/list",
    version: API_VERSION.V0,
  },
  GET_All_ORGANIZATION_LIST: {
    method: EMethod.POST,
    url: "/corp/organization/list",
    version: API_VERSION.V0,
  },
  GET_CLIENT_BASIC_INFO: {
    method: EMethod.GET,
    url: "/user/client/kensaku-information",
    version: API_VERSION.V1,
  },
  GET_WORK_LOCATION_LIST: {
    method: EMethod.POST,
    url: "/corp/work-location/list",
    version: API_VERSION.V0,
  },
  GET_OTHER_FACILITIES_LIST: {
    method: EMethod.POST,
    url: "/corp/organization/other-facilities/list",
    version: API_VERSION.V0,
  },
  GET_BUSINESS_ESTABLISHMENT_DETAIL: {
    method: EMethod.GET,
    url: "/corp/business-establishment/kensaku-information",
    version: API_VERSION.V0,
  },
  GET_ORGANIZATION_DETAIL: {
    method: EMethod.GET,
    url: "/corp/organization/kensaku-information",
    version: API_VERSION.V0,
  },
  GET_COMMANDER_LIST: {
    method: EMethod.GET,
    url: "/corp/member/client/job-listing/filter",
    version: API_VERSION.V0,
  },
  GET_JOB_LISTING_DETAILS: {
    method: EMethod.GET,
    url: "/corp/job-listing/detail/{idJobListing}",
    version: API_VERSION.V0,
  },
};
